import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { OptionType } from "@/types/OptionType";

export class CurrencyDto extends BaseEntityDto {
  code: string;
  isoCode: string;
  label: string;
  exchangeRate: number;
  isDefault: boolean;

  toString(): string {
    return `${this.code} (${this.label})`;
  }

  mapEntityToOptionType(labels: string[]): OptionType {
    return {
      label: labels.join(" "),
      value: this.id,
    };
  }
}
